import i18n from '../../i18n';

export class Text {
  static get duration(): string {
    return i18n._translate('total time', {
      context: 'A heading above the total amount of time spent doing workouts. E.g. 8:08',
    });
  }

  static get distance(): string {
    return i18n._translate('distance', {
      context: 'A heading above a number showing how many miles have been achieved doing workouts. E.g. 0.06 mi',
    });
  }

  static get calories(): string {
    return i18n._translate('est cal burned', {
      context:
        'A heading that is abbreviated to say "Estimated Calories Burned" over a number of calories. E.g. 65 cals',
    });
  }

  static get elevation(): string {
    return i18n._translate('elevation gain', {
      context: 'A heading above a number showing how many feet the user has climbed during a workout. E.g. 4 ft',
    });
  }

  static get pace(): string {
    return i18n._translate('pace', {
      context: 'A heading above a number showing the user has a certain time per mile completed. E.g. 2:13:34 /mi',
    });
  }

  static get averagePower(): string {
    return i18n._translate('average power', {
      context: 'A heading above a number telling the user what their average power is across all their workouts.',
    });
  }

  static get averageSplit(): string {
    return i18n._translate('average 500m split', {
      context: 'A heading above a number telling the user what their average split is across all their workouts.',
    });
  }
}
